<!--
Author: TangChen
Date: 2018-10-17
Desc: 注销账户页面，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-close-acct bizcomp ' + className">
        <comp-title :title="title" />
        <!-- 账户注销申请 -->
        <div>
            <nav-tips :data="titTips" />
            <div class="con">
                <!-- 确认信息 -->
                <el-row
                    v-for="(item,index) in confirmInfo"
                    :key="item.id"
                    class="confirm-item"
                >
                    <el-col :span="12" :offset="6">
                        <span class="item-circle">{{ index + 1 }}</span>
                        <span class="item-tit">{{ item.tit }}</span>
                    </el-col>
                </el-row>
                <!-- 按钮区 -->
                <el-row class="btn-group">
                    <el-col :span="12" :offset="8">
                        <el-button
                            type="primary"
                            class="medium"
                            v-on:click="popConfirmBox"
                        >
                            {{ btn1 }}
                        </el-button>
                        <el-button class="medium" v-on:click="back">
                            {{ btn2 }}
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 确认密码 -->
        <el-dialog :title="pwdMsg.tit" :visible.sync="pwdVisible" top="40vh" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <el-form
                    ref="ruleForm"
                    class="two-cols-form pwd-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="87px"
                >
                    <el-form-item label="" prop="password">
                        <el-input
                            v-model="ruleForm.password"
                            type="password"
                            :maxlength="20"
                            :placeholder="pwdMsg.pla"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="pwd-dialog-footer">
                <el-button v-on:click="pwdVisible = false">
                    取消
                </el-button>
                <el-button type="primary" v-on:click="cancelConfirm(ruleForm.password)">
                    确定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navTips from "@/components/form/navTips.vue";
export default {
    name: "CloseAcct",
    components: {
        navTips
    },
    mixins: [mixin],
    data () {
        return {
            titTips: {
                tit: "账户注销申请",
                text: "在提交注销申请前，请先确保符合以下条件，保护您的账户和财产安全",
                cla: "close-acct"
            },
            confirmInfo: [
                { tit: "网上交易中已无任何基金份额；", id: "00" },
                { tit: "当日交易账户已无任何业务申请；", id: "01" },
                {
                    tit: "交易账户无未确认交易申请；",
                    id: "02"
                },
                {
                    tit: "交易账户状态正常,未被冻结或挂失等；",
                    id: "03"
                },
                {
                    tit: "无生效中(含暂停状态)的定投协议；",
                    id: "04"
                },
                {
                    tit: "如有未解约支付协议，可登录个人网银解约。",
                    id: "05"
                }
            ],
            pwdMsg: {
                tit: "交易密码输入框",
                pla: "请输入您的交易密码",
                errorTips: "请输入交易密码"
            },
            pwdVisible: false,
            errorMsg: "",
            btn1: "申请注销",
            btn2: "返回",
            ruleForm: {
                password: ""
            },
            rules: {
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" }
                ]
            }
        };
    },
    watch: {
        pwdVisible(val){
            if(this.$refs.ruleForm){
                this.$refs.ruleForm.resetFields();
            }
        }
    },
    mounted () {
        const {usertype} = this.$cache.getUser();
        if(!["3","4"].includes(usertype)){
            this.pwdMsg.tit = "登录密码输入框";
            this.pwdMsg.pla = "请输入您的登录密码";
            this.pwdMsg.errorTips = "请输入登录密码";
        }
    },
    methods: {
        // 回到上一级页面
        back(){
            this.$router.back();
        },
        popConfirmBox() {
            this.$confirm("注销操作将删除账户所有的数据并且不可恢复，操作完成后将退出系统", "温馨提示", {
                confirmButtonText: "我已知晓",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                this.pwdVisible = true;
            });
        },
        //输入密码确认
        cancelConfirm(val){
            var _this = this;
            _this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    _this.pwdVisible = false;
                    _this.handleCancelAcct (val);
                }else {
                    return false;
                }
            });
        },
        //账户注销
        handleCancelAcct(val){
            if(this.$util.isEmpty(val)) return;
            let params = {
                tradepwd: this.$util.enc(val)
            };

            this.$util.request("acct/cust/closing", params,"POST").then(res => {
                if(res.data[0][0] && res.data[0][0].appsheetserialno){
                    setTimeout(() => {
                        this.logoff();
                    }, 1000);
                }else{
                    this.errorMsg = res.msg;
                    this.$alert(this.errorMsg, "提示", {
                        dangerouslyUseHTMLString: true
                    });
                }
            });
        },
        /**
         * 登出系统
         */
        logoff () {
            const _this = this;
            _this.$message({
                type: "success",
                message: "销户成功!",
                onClose: function () {
                    _this.$util.request("common/logout", {}, false, false).then(res => {
                        if (res.data) {
                            _this.$store.dispatch("logout", res.data[0]).then(() => {
                                _this.$router.replace("/");
                            });
                        }
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/varibles';
.bizcomp-close-acct {
    .confirm-item{
        margin-bottom: 1rem;
        .item-circle{
            display: inline-block;
            width: 1.65rem;
            height: 1.65rem;
            border-radius: 50%;
            border: 1px solid #F64D3E;

            font-size: 1.1rem;
            font-weight: 400;
            color: #EF4034;
            line-height: 1.5rem;
            text-align: center;
            margin-right: 0.5rem;
        }
        .item-tit{
            font-size: 1.2rem;
            font-weight: 400;
            color: #929292;
            line-height: 2rem;
        }
    }
    .confirm-item:last-child{
        margin-bottom: 0;
    }

    .btn-group {
        margin-bottom: 2rem;
        .el-button.medium{
            margin-right: 5rem
        }
    }
    .pwd-form {
        margin-top:15px;
    }
    .pwd-dialog-footer {
            text-align: center;
            .el-button {
                min-width: 50px;
                line-height: 15px;
                padding: 9px 20px;
                font-size: $f12;
            }
            button:nth-child(2) {
                margin-left: 34px;
            }
        }
}
</style>
